import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { Box, Button, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

const TechnicalError = ({ reloadFn }: { reloadFn: () => void }) => {
  const { t, ready } = useTranslation("common", { useSuspense: false });
  const subtitles = [t("technicalError.subtitle")];
  const title = t("technicalError.title");
  if (!ready) {
    return <></>;
  }
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        alignItems: "center",
        marginTop: "40vh",
      }}
      data-testid="error-page"
    >
      <WarningAmberIcon
        data-testid="error-icon"
        color="warning"
        fontSize="large"
      />
      <Typography
        sx={{
          textAlign: "center",
          paddingTop: "1.5rem",
          paddingBottom: "0.75rem",
          fontWeight: "600",
        }}
        data-testid="error-title"
        component="h2"
      >
        {title}
      </Typography>
      <Box data-testid="error-subtitles">
        {subtitles.map((content, idx) => (
          <Typography sx={{ textAlign: "center" }} key={`subtitle-${idx + 1}`}>
            {content}
          </Typography>
        ))}
      </Box>
      <Button
        sx={{ marginTop: "1.5rem", width: "140px", backgroundColor: "#FFDE00" }}
        variant="primary"
        data-testid="error-reloadScreen"
        onClick={reloadFn}
      >
        {t("authentication.failed.reload")}
      </Button>
    </Box>
  );
};

export default TechnicalError;
